export class DataRow {
  rowNumber: number;
  timeJulian: number;
  timeJ2000: number;
  frequency: number;
  dsn: number;
}
